import { readFileAsDataURL } from '@shared/utils/media/file'
import { loadImage } from '@shared/utils/media/image'

/**
 * 判断本地图片文件是否满足最小要求尺寸
 * @param {File} imageFile 图片文件
 * @param {number} minWidth 最小宽度
 * @param {number} minHeight 最小高度
 */
export async function isImageFileMatchRequiredSize(imageFile, minWidth, minHeight) {
  const dataUrl = await readFileAsDataURL(imageFile)
  const image = await loadImage(dataUrl)
  if (image.width < minWidth || image.height < minHeight) {
    return Promise.reject(new Error(`图片尺寸不小于${minWidth}x${minHeight}`))
  }
}
